<template>
  <SlideYUpTransition>
    <div
      v-if="getActiveComment && getActiveComment.show"
      v-click-outside="closeBox"
      class="comment-box smooth-shadow"
      :style="{
        top: `${getActiveComment.y + 10}px`,
        left: `${getActiveComment.x + 10}px`,
      }"
    >
      <div class="box-header">
        <h4 class="title"><Icon size="18">comment</Icon>Comment</h4>
        <!-- <Icon type="button" size="18" @click="closeBox">clear</Icon> -->
      </div>
      <p class="comment" placeholder="Enter your comment here">
        {{ getActiveComment.comment.properties.message }}
      </p>
      <!-- <div class="button-area">
      <button v-if="!isLoading" class="btn-option delete">
        <Icon size="18">delete</Icon>
        Delete
      </button>
      <button v-if="!isLoading" class="btn-option" @click="saveComment">
        <Icon size="18">check</Icon>
        Save Comment
      </button>
      <Spinner v-if="isLoading" small />
    </div> -->
    </div>
  </SlideYUpTransition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    SlideYUpTransition,
  },
  props: {
    mode: String,
    data: Object,
  },
  data() {
    return {
      isLoading: false,
      comment: null,
      message: null,
    };
  },
  computed: {
    ...mapGetters("Comments", ["getActiveComment"]),
  },
  methods: {
    // ...mapActions('Comments', ['addComment', 'updateComment', 'deleteComment']),
    closeBox() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-box {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  max-width: 350px;
  height: auto;
  padding: 10px;
  background: var(--color-secondary);
  border-radius: 5px;
  z-index: 100;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;

    i {
      margin-right: 10px;
    }
  }

  .comment {
    border: 0;
    // background-color: var(--color-default-background);
    color: var(--font-color);
    border-radius: 3px;
    margin: 0;
    height: auto;
    min-width: 200px;
  }

  .box-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .button-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 5px 0;

    .btn-option {
      display: flex;
      align-items: center;
      border: 0;
      padding: 10px;
      background: transparent;
      color: var(--color-primary);
      border-radius: 5px;
      outline: none;

      i {
        margin-right: 5px;
      }

      &:hover {
        cursor: pointer;
        background-color: var(--color-primary-light);
      }

      &.delete {
        color: rgb(221, 106, 12);

        &:hover {
          background: var(--border-color);
        }
      }
    }
  }

  //   &:after {
  //     position: absolute;
  //     content: "";
  //     top: -20px;
  //     left: 0px;
  //     right: 0;
  //     width: 10px;
  //     height: 10px;
  //     background-color: var(--color-primary);
  //     border-radius: 50px;
  //     border: 2px solid var(--color-primary-light);
  //   }
}
</style>
